<div>
    <h2>{{'mantenimientoIncidencias.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} {{rolePermission ? '' : '*'}}</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.denominacion' | translate}} {{rolePermission ? '' : '*'}}</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.campanya' | translate}} {{rolePermission ? '' : '*'}}</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanyas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.provincia' | translate}}</label>
                <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')"
                    [disabled]="disabledProvincias" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.municipio' | translate}}</label>
                <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')"
                    [disabled]="disabledMunicipios" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.etiquetador' | translate}}</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.confeccion' | translate}}</label>
                <app-filterable-list [itemsList]="confecciones" [selectedItem]="filtersForm.get('confeccion')"
                    [disabled]="disabledConfecciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.almacen' | translate}}</label>
                <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
                    [disabled]="disabledAlmacenes" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.destino' | translate}}</label>
                <app-filterable-list [itemsList]="destinos" [selectedItem]="filtersForm.get('paisDestino')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.finca' | translate}}</label>
                <input type="text" formControlName="finca">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.productor' | translate}}</label>
                <input type="text" formControlName="productor">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.licencia' | translate}}</label>
                <input type="text" formControlName="licencia">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.codigoSNC' | translate}}</label>
                <input type="text" formControlName="snc">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.consumo.titulo' | translate}}</label>
                <app-filterable-list [itemsList]="tiposConsumo" [selectedItem]="filtersForm.get('consumo')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoIncidencias.filters.estado.titulo' | translate}}</label>
                <app-filterable-list [itemsList]="estadosIncidencia" [selectedItem]="filtersForm.get('estado')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'mantenimientoIncidencias.filters.fechaIncidencia' | translate}}</label>
                <input [matDatepicker]="fechaIncidencia" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaIncidencia"
                    (click)="fechaIncidencia.open()">
                <mat-datepicker #fechaIncidencia></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'mantenimientoIncidencias.filters.fechaGestionada' | translate}}</label>
                <input [matDatepicker]="fechaGestionada" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaGestionada"
                    (click)="fechaGestionada.open()">
                <mat-datepicker #fechaGestionada></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'mantenimientoIncidencias.filters.fechaConsumo' | translate}}</label>
                <input [matDatepicker]="fechaConsumo" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaConsumo"
                    (click)="fechaConsumo.open()">
                <mat-datepicker #fechaConsumo></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
        <i *ngIf="this.role === 'Administrador' || this.claims.includes('D_INC_Export')" class="fas fa-file-pdf" [ngClass]="{'disabled': !incidencias || incidencias.length < 1}"
          (click)="exportModal = 1" title="{{'mantenimientoIncidencias.exportarA' | translate}} PDF"></i>
        <i *ngIf="this.role === 'Administrador' || this.claims.includes('D_INC_Export')" class="fas fa-file-csv" [ngClass]="{'disabled': !incidencias || incidencias.length < 1}"
          (click)="exportModal = 2" title="{{'mantenimientoIncidencias.exportarA' | translate}} CSV"></i>
        <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                  <tr>
                    <th class="icon"></th>
                    <th class="id sortable" (click)="toOrderBy('x=> x.id', 1)">ID
                      <i [ngClass]="getIcon('x=> x.id')"></i>
                    </th>
                    <th class="icon"></th>
                    <th class="date sortable" (click)="toOrderBy('x=> x.fecha', 2)">
                      {{'mantenimientoIncidencias.table.fechaIncidencia' | translate}}
                      <i [ngClass]="getIcon('x=> x.fecha')"></i>
                    </th>
                    <th class="string sortable" (click)="toOrderBy('x=> x.Consumo.Almacen.Etiquetador.Des', 3)">
                      {{'mantenimientoIncidencias.table.etiquetador' | translate}}
                      <i [ngClass]="getIcon('x=> x.Consumo.Almacen.Etiquetador.Des')"></i>
                    </th>
                    <th class="string sortable" (click)="toOrderBy('x=> x.Consumo.ConsumosDetalle.First().Designacion.Cultivo.Finca.Des', 4)">
                      {{'global.finca' | translate}}
                      <i [ngClass]="getIcon('x=> x.Consumo.ConsumosDetalle.First().Designacion.Cultivo.Finca.Des')"></i>
                    </th>
                    <th class="string sortable" (click)="toOrderBy('x=> x.Consumo.Confeccion.Des', 5)">
                      {{'mantenimientoIncidencias.table.confeccion' | translate}}
                      <i [ngClass]="getIcon('x=> x.Consumo.Confeccion.Des')"></i>
                    </th>
                    <th class="date sortable" (click)="toOrderBy('x=> x.Consumo.fechaIns', 6)">
                      {{'mantenimientoIncidencias.table.fechaConfeccion' | translate}}
                      <i [ngClass]="getIcon('x=> x.Consumo.fechaIns')"></i>
                    </th>
                    <th class="string sortable" (click)="toOrderBy('x=> x.Consumo.seriadoFijo', 7)">
                      {{'mantenimientoIncidencias.table.codigoSNC' | translate}}
                      <i [ngClass]="getIcon('x=> x.Consumo.seriadoFijo')"></i>
                    </th>
                    <th class="string-short">{{'mantenimientoIncidencias.table.unidades' | translate}}</th>
                    <th class="string">{{'mantenimientoIncidencias.table.kilos' | translate}}</th>
                    <th class="multi-actions-bigSubtable">
                        <i class="fas fa-plus" *ngIf="this.role === 'Administrador' || this.claims.includes('INC_Ins')"
                        (click)="create()" title="{{'mantenimientoIncidencias.tituloNew' | translate}}"></i>
                    </th>
                  </tr>
                </thead>
                <tbody class="clickable" *ngFor="let incidencia of incidencias; let i=index; trackBy: trackByIncidenciaId">
                    <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                        <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                            title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                        </td>
                        <td class="id">{{incidencia.id}}</td>
                        <td>
                            <i *ngIf="incidencia.gestionada" class="far fa-check-circle" title="{{'titles.incidenciaGestionada' | translate}}"></i>
                        </td>
                        <td class="date">{{incidencia.fecha | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="string">{{incidencia.desEtiquetador}}</td>
                        <td class="string">{{incidencia.desFinca}}</td>
                        <td class="string">{{incidencia.desConfeccion}}</td>
                        <td class="date">{{incidencia.fechaInsConsumo | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="string">{{incidencia.seriadoFijo}}<br>({{('0000' + incidencia.seriadoInicio).slice(-4)}} &ndash;
                            {{( '0000' + incidencia.seriadoFin).slice(-4)}})</td>
                        <td class="string-short">{{incidencia.numeroEtiquetasEfectivas}} /
                            {{incidencia.numeroEtiquetasImpresas}}</td>
                        <td class="string">{{incidencia.kilosEfectivosIncidencia | number : '1.2-2': defaultLanguage}} /
                            {{incidencia.kilosImpresosTotales | number : '1.2-2': defaultLanguage}}</td>
                        <td class="multi-actions-bigSubtable">
                            <i *ngIf="incidencia.existenReimpresiones" class="fa-solid fa-print" title="{{'titles.tieneReimpresiones' | translate}}"
                            (click)="showReimpresiones(incidencia)"></i>
                            <i  [ngClass]="incidencia.gestionada ? (rolePermission ? 'fas fa-pencil-alt' : 'fas fa-eye') : (rolePermission || this.claims.includes('INC_Upd') ? 'fas fa-edit' : '')"
                                *ngIf="this.role === 'Administrador' || this.claims.includes('INC_Upd')"
                                (click)="update(incidencia)"></i>
                            <i class="far fa-trash-alt" *ngIf="!incidencia.registroEnUso && (this.role === 'Administrador' || this.claims.includes('INC_Del'))"
                                (click)="askDelete(incidencia)" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownInfo === i">
                        <td colspan="14">
                            <div class="detail">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.productor' | translate}}</label>
                                    <p>{{incidencia.desProductor}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.descripcion' | translate}}</label>
                                    <p>{{incidencia.des}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.respuesta' | translate}}</label>
                                    <p>{{incidencia.respuestaGST}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.tipoIncidencia' | translate}}</label>
                                    <p>{{incidencia.desTipoIncidenciaRazon}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.etiquetasGuardadas' | translate}}</label>
                                    <p>{{incidencia.etiquetasDisponibles ? 'Sí' : 'No'}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.unidadesConsumo' | translate}}</label>
                                    <p>{{incidencia.numeroEtiquetasSolicitadas}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.unidadesDevueltas' | translate}}</label>
                                    <p>{{incidencia.numeroEtiquetasEfectivas}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.personaContacto' | translate}}</label>
                                    <p>{{incidencia.nombrePersonaAltaIncidencia}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoIncidencias.table.email' | translate}}</label>
                                    <p>{{incidencia.correoPersonaAltaIncidencia}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'global.fecha.insercionShort' | translate}}</label>
                                    <p>{{incidencia.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'global.fecha.actualizacionShort' | translate}}</label>
                                    <p>{{incidencia.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</p>
                                </div>
                                <div class="block-inline"></div>
                                <div class="block-inline"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!incidencias || (incidencias && incidencias.length < 1)">
                    <tr>
                        <td colspan="14">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="incidencias && incidencias.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event; showWarning=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>
                {{incidenciaGestionada && !rolePermission ? ('mantenimientoIncidencias.tituloConsultar' | translate) : consumoId
                && rolePermission ? ('mantenimientoIncidencias.tituloGestion' | translate) : consumoId && !rolePermission ?
                ('mantenimientoIncidencias.tituloEdit' | translate) : ('mantenimientoIncidencias.tituloNew' | translate)}}
            </h4>
        </header>
        <app-mantenimiento-inc-new-edit [consumoId]="consumoId" [incidenciaId]="incidenciaId"
            (close)="newEditModal = !newEditModal" (refresh)="refresh($event)" (mensaje)="this.pushMessage($event)">
        </app-mantenimiento-inc-new-edit>
    </div>
</div>
<div class="modal" *ngIf="exportModal > 0">
    <div class="modal-content">
      <header>
        <h4>{{'global.modalInformes.titulo' | translate}} {{exportModal === 1 ? 'PDF' : 'CSV'}}</h4>
        <i class="fas fa-times" (click)="exportModal = 0"></i>
      </header>
      <content>
        <button (click)="exportPdfOrCsv(1)">{{'global.modalInformes.general' | translate}}</button>
        <button (click)="exportPdfOrCsv(2)">{{'global.modalInformes.detallado' | translate}}</button>
      </content>
    </div>
</div>
<div class="modal" *ngIf="reimpresionesModal">
    <div class="modal-content">
        <header>
            <h4>{{'consumos.reimpresiones.titulo' | translate}}</h4>
        </header>
        <app-reimp-consumos class="component" [consumoId]="consumoId" (refresh)="refresh($event)">
        </app-reimp-consumos>
    </div>
</div>
